<script setup lang="ts">
defineProps<{
  title: string;
  description?: string;
}>();
</script>

<template>
  <div class="text-center">
    <p class="font-bold">{{ title }}</p>
    <p v-if="description" class="text-text-secondary">
      {{ description }}
    </p>
  </div>
</template>
